/* tslint:disable */
/* eslint-disable */
/* @relayHash d09df12d8c80493e1d35409650fbb846 */

import { ConcreteRequest } from "relay-runtime";
export type DeleteDesignProjectMutationInput = {
    projectId: string;
    clientMutationId?: string | null;
};
export type deleteDesignProjectMutationVariables = {
    input: DeleteDesignProjectMutationInput;
};
export type deleteDesignProjectMutationResponse = {
    readonly deleteDesignProjectMutation: {
        readonly projectId: string | null;
    } | null;
};
export type deleteDesignProjectMutation = {
    readonly response: deleteDesignProjectMutationResponse;
    readonly variables: deleteDesignProjectMutationVariables;
};



const node: ConcreteRequest = (function(){
var v0 = [
  {
    "kind": "LocalArgument",
    "name": "input",
    "type": "DeleteDesignProjectMutationInput!",
    "defaultValue": null
  }
],
v1 = [
  {
    "kind": "LinkedField",
    "alias": null,
    "name": "deleteDesignProjectMutation",
    "storageKey": null,
    "args": [
      {
        "kind": "Variable",
        "name": "input",
        "variableName": "input"
      }
    ],
    "concreteType": "DeleteDesignProjectMutationPayload",
    "plural": false,
    "selections": [
      {
        "kind": "ScalarField",
        "alias": null,
        "name": "projectId",
        "args": null,
        "storageKey": null
      }
    ]
  }
];
return {
  "kind": "Request",
  "fragment": {
    "kind": "Fragment",
    "name": "deleteDesignProjectMutation",
    "type": "Mutations",
    "metadata": null,
    "argumentDefinitions": (v0/*: any*/),
    "selections": (v1/*: any*/)
  },
  "operation": {
    "kind": "Operation",
    "name": "deleteDesignProjectMutation",
    "argumentDefinitions": (v0/*: any*/),
    "selections": (v1/*: any*/)
  },
  "params": {
    "operationKind": "mutation",
    "name": "deleteDesignProjectMutation",
    "id": "app-buyer-trade/267.0.0-2020-06-02T16:23:38.038Z/deleteDesignProjectMutation",
    "text": null,
    "metadata": {}
  }
};
})();
(node as any).hash = 'd71836c0fe3ec009bdc57b12e25c6fd6';
export default node;
